export default __webpack_public_path__ + "static/media/bot.ded04705.png";